module.exports = __webpack_public_path__ + "img/A58A0997.4f19e243.jpg";